import { render, staticRenderFns } from "./LeadFollowUpProgress.vue?vue&type=template&id=2e04b8e9&scoped=true&"
import script from "./LeadFollowUpProgress.vue?vue&type=script&lang=js&"
export * from "./LeadFollowUpProgress.vue?vue&type=script&lang=js&"
import style0 from "./LeadFollowUpProgress.vue?vue&type=style&index=0&id=2e04b8e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e04b8e9",
  null
  
)

export default component.exports